export const getRandomCode = (length = 6) => {
    const numbers = '0123456789';
    const lowerLetters = 'abcdefghijklmnopqrstuvwxyz';
    const upperLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const allChars = numbers + lowerLetters + upperLetters;

    let result = '';
    let hasNumber = false;
    let hasLetter = false;

    // Ensure at least one number and one letter are included.
    result += numbers[Math.floor(Math.random() * numbers.length)];
    hasNumber = true;
    result += lowerLetters[Math.floor(Math.random() * lowerLetters.length)] || upperLetters[Math.floor(Math.random() * upperLetters.length)];
    hasLetter = true;

    // Fill the rest of the string length with random characters from allChars.
    for (let i = 2; i < length; i++) {
        result += allChars[Math.floor(Math.random() * allChars.length)];
    }

    // Shuffle the result to ensure randomness in position of numbers and letters.
    result = result.split('').sort(() => Math.random() - 0.5).join('');

    return result;
}

export const getMonthRange = (selectedMonth) => {
    selectedMonth = selectedMonth || new Date();
    const date = new Date(selectedMonth);
    // 获取本月第一天
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    // 获取本月最后一天
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return {
        DTS: formatDate(firstDay),
        DTE: formatDate(lastDay),
    }
}

export const getYearRange = (d) => {
    d = d || new Date();
    let year = new Date(d).getFullYear();
    const firstDay = new Date(year, 0, 1);
    const lastDay = new Date(year, 11, 31);
    return {
        DTS: formatDate(firstDay),
        DTE: formatDate(lastDay),
    };
}
export const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

